var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import sendJsonRequest from './helpers/sendJsonRequest';
import messageFiltersToSearchParams from './helpers/messageFiltersToSearchParams';
export var getAuthUser = function (apiBaseUrl) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, sendJsonRequest({ url: "".concat(apiBaseUrl, "/auth/user") })];
}); }); };
export var getChats = function (apiBaseUrl) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, sendJsonRequest({ url: "".concat(apiBaseUrl, "/chats") })];
}); }); };
export var createChat = function (apiBaseUrl, name, api) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, sendJsonRequest({
                body: { api: api, name: name },
                method: 'POST',
                url: "".concat(apiBaseUrl, "/chats")
            })];
    });
}); };
export var updateChat = function (apiBaseUrl, _a) { return __awaiter(void 0, void 0, void 0, function () {
    var id = _a.id, chat = __rest(_a, ["id"]);
    return __generator(this, function (_b) {
        return [2 /*return*/, sendJsonRequest({
                body: chat,
                method: 'PATCH',
                url: "".concat(apiBaseUrl, "/chats/").concat(id)
            })];
    });
}); };
export var softDeleteChat = function (apiBaseUrl, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, sendJsonRequest({
                method: 'DELETE',
                url: "".concat(apiBaseUrl, "/chats/").concat(id)
            })];
    });
}); };
export var generateChatName = function (apiBaseUrl, chatId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, sendJsonRequest({
                method: 'POST',
                url: "".concat(apiBaseUrl, "/chats/").concat(chatId, "/generate-name")
            })];
    });
}); };
export var getChatMessages = function (apiBaseUrl, id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, sendJsonRequest({ url: "".concat(apiBaseUrl, "/chats/").concat(id, "/messages") })];
}); }); };
export var generateNextMessage = function (apiBaseUrl, chatId, content) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, sendJsonRequest({
                body: { content: content },
                method: 'POST',
                url: "".concat(apiBaseUrl, "/chats/").concat(chatId, "/messages/generate")
            })];
    });
}); };
export var regenerateMessage = function (apiBaseUrl, chatId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, sendJsonRequest({
                method: 'POST',
                url: "".concat(apiBaseUrl, "/chats/").concat(chatId, "/messages/regenerate")
            })];
    });
}); };
export var getUserSettings = function (apiBaseUrl) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, sendJsonRequest({ url: "".concat(apiBaseUrl, "/user-settings") })];
}); }); };
export var updateUserSettings = function (apiBaseUrl, settings) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, sendJsonRequest({
                body: settings,
                method: 'PATCH',
                url: "".concat(apiBaseUrl, "/user-settings")
            })];
    });
}); };
export var getUsers = function (apiBaseUrl) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, sendJsonRequest({ url: "".concat(apiBaseUrl, "/users") })];
}); }); };
export var getUserChats = function (apiBaseUrl, id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, sendJsonRequest({ url: "".concat(apiBaseUrl, "/users/").concat(id, "/chats") })];
}); }); };
export var getMessages = function (apiBaseUrl, messageFilters) { return __awaiter(void 0, void 0, void 0, function () {
    var url, searchParams, _i, _a, _b, key, value;
    return __generator(this, function (_c) {
        url = new URL("".concat(apiBaseUrl, "/messages"));
        searchParams = messageFiltersToSearchParams(messageFilters);
        for (_i = 0, _a = Array.from(searchParams.entries()); _i < _a.length; _i++) {
            _b = _a[_i], key = _b[0], value = _b[1];
            url.searchParams.append(key, value);
        }
        return [2 /*return*/, sendJsonRequest({ url: url.toString() })];
    });
}); };
export var getApiSources = function (apiBaseUrl, api, type) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        url = new URL("".concat(apiBaseUrl, "/apis/").concat(api, "/sources"));
        if (type) {
            url.searchParams.append('type', type);
        }
        return [2 /*return*/, sendJsonRequest({ url: url.toString() })];
    });
}); };
export var getApiSourceFiles = function (apiBaseUrl, api, sourceId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, sendJsonRequest({ url: "".concat(apiBaseUrl, "/apis/").concat(api, "/sources/").concat(sourceId, "/files") })];
}); }); };
export var uploadFiles = function (apiBaseUrl, api, sourceId, files) { return __awaiter(void 0, void 0, void 0, function () {
    var body, _i, files_1, file;
    return __generator(this, function (_a) {
        body = new FormData();
        for (_i = 0, files_1 = files; _i < files_1.length; _i++) {
            file = files_1[_i];
            body.append('files', file);
        }
        return [2 /*return*/, sendJsonRequest({
                body: body,
                method: 'POST',
                url: "".concat(apiBaseUrl, "/apis/").concat(api, "/sources/").concat(sourceId, "/files")
            })];
    });
}); };
export var deleteFile = function (apiBaseUrl, api, sourceId, name) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, sendJsonRequest({
                method: 'DELETE',
                url: "".concat(apiBaseUrl, "/apis/").concat(api, "/sources/").concat(sourceId, "/files/").concat(encodeURIComponent(name))
            })];
    });
}); };
